const EMPTY_OBJECT_ID = "000000000000000000000000";

export function isMeaningfulObjectId(id: unknown): boolean {
  const s = String(id ?? "").trim();
  return !!s && s !== EMPTY_OBJECT_ID;
}

export type InstallationLineItemImage = { url: string; alt_text?: string; default?: boolean };

export type InstallationLineItemImageSource = {
  design_id?: string;
  preview_url?: string;
  images?: Array<{ url: string; alt_text?: string; default?: boolean }>;
  image_url?: string;
};

export function normalizeInstallationLineItemImages(imgs: unknown): InstallationLineItemImage[] {
  if (!Array.isArray(imgs)) return [];
  return imgs
    .map((img: { url?: unknown; alt_text?: string; default?: boolean }) => {
      const url = String(img?.url ?? "").trim();
      if (!url) return null;
      return {
        url,
        ...(img.alt_text != null ? { alt_text: img.alt_text } : {}),
        ...(img.default != null ? { default: img.default } : {}),
      };
    })
    .filter((x): x is InstallationLineItemImage => x != null);
}

/** Build `images` for installation line_items — matches SignageAddInstallation; preserves API file ids on edit. */
export function buildInstallationLineItemImages(args: {
  product: InstallationLineItemImageSource;
  originalLine?: { images?: unknown; design_id?: unknown; preview_url?: unknown } | null;
  variantCatalogImages?: unknown;
}): InstallationLineItemImage[] {
  const { product, originalLine, variantCatalogImages } = args;

  const designId = isMeaningfulObjectId(product.design_id)
    ? String(product.design_id).trim()
    : isMeaningfulObjectId(originalLine?.design_id)
      ? String(originalLine!.design_id).trim()
      : "";
  const previewUrl = String(product.preview_url ?? originalLine?.preview_url ?? "").trim();

  if (designId && previewUrl) {
    return [{ url: previewUrl }];
  }

  const fromOriginal = normalizeInstallationLineItemImages(originalLine?.images);
  if (fromOriginal.length > 0) return fromOriginal;

  const fromProduct = normalizeInstallationLineItemImages(product.images);
  if (fromProduct.length > 0) return fromProduct;

  const fromVariant = normalizeInstallationLineItemImages(variantCatalogImages);
  if (fromVariant.length > 0) return fromVariant;

  const imageUrl = String(product.image_url ?? "").trim();
  if (imageUrl) return [{ url: imageUrl }];

  return [];
}
